module.exports = __webpack_public_path__ + "static/media/7.51713f1d.png";